import Skelet from '../Skelet';
import styles from '../../styles/modules/buildings/BuildingsCatalogItem.module.scss';

const BuildingsCatalogSkeletonItem = () => {
  return (
    <div className={styles.item}>
      <div className={styles.itemBuilding}>
        <Skelet className={styles.itemBuildingTitle} height={33} width={200} />
        <Skelet className={styles.itemBuildingSubtitle} height={21} width={300} />
        <Skelet className={styles.itemBuildingDescription} height={100} />
        <div className={styles.itemBuildingPreview}>
          <Skelet style={{ height: 200 }} />
        </div>
      </div>
      <div className={styles.itemContent}>
        <div className={styles.itemLabels}>
          <Skelet
            className={styles.itemLabel}
            width={80}
            height={80}
            style={{ borderRadius: '50%' }}
          />
          <Skelet
            className={styles.itemLabel}
            width={80}
            height={80}
            style={{ borderRadius: '50%' }}
          />
          <Skelet
            className={styles.itemLabel}
            width={80}
            height={80}
            style={{ borderRadius: '50%' }}
          />
        </div>
        <div className={styles.itemVariants}>
          <Skelet
            className={styles.itemVariant}
            style={{ width: 'calc(100% - 32px)', height: '80px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default BuildingsCatalogSkeletonItem;
